import { render, staticRenderFns } from "./TalleresView.vue?vue&type=template&id=471bd39d&"
import script from "./TalleresView.vue?vue&type=script&lang=ts&"
export * from "./TalleresView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports